import { useEffect, useState } from "react";
import { http } from "@/lib/api";

const TFS = ["15m", "1H", "4H", "1D"];

export default function GoldChart({ signal, asset = "XAU" }) {
  const [tf, setTf] = useState("1H");
  const [cs, setCs] = useState([]);
  useEffect(() => { http.get("/gold/candles", { params: { tf, asset } }).then((r) => setCs(r.data)); }, [tf, asset, signal?.id]);

  const W = 600, H = 260, P = 8;
  const d = signal?.data;
  const levels = d && d.segnale !== "ATTENDI" ? [["Entrata", d.entrata, "#EAB308"], ["SL", d.stop_loss, "#EF4444"], ["TP1", d.take_profit_1, "#10B981"], ["TP2", d.take_profit_2, "#10B981"]].filter((l) => l[1] != null) : [];
  const vals = cs.flatMap((c) => [c.h, c.l]).concat(levels.map((l) => l[1]));
  const min = Math.min(...vals), max = Math.max(...vals);
  const y = (v) => P + (H - 2 * P) * (1 - (v - min) / (max - min || 1));
  const bw = (W - 2 * P) / Math.max(cs.length, 1);

  return (
    <div data-testid="gold-chart" className="panel p-5 space-y-3">
      <div className="flex items-center justify-between">
        <span className="font-mono text-xs text-slate-400">{asset}/USDT · {tf}</span>
        <div className="flex gap-1">
          {TFS.map((t) => <button key={t} data-testid={`gold-tf-${t}`} onClick={() => setTf(t)} className={`px-2 py-1 rounded text-xs font-mono transition-colors ${tf === t ? "bg-[var(--gold)] text-slate-950" : "text-slate-400 hover:text-white"}`}>{t}</button>)}
        </div>
      </div>
      {cs.length === 0 ? <div className="h-[260px] scan rounded" /> : (
        <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto">
          {cs.map((c, i) => {
            const up = c.c >= c.o, x = P + i * bw + bw / 2, col = up ? "#10B981" : "#EF4444";
            return (
              <g key={c.t}>
                <line x1={x} x2={x} y1={y(c.h)} y2={y(c.l)} stroke={col} strokeWidth="1" />
                <rect x={x - bw * 0.35} width={bw * 0.7} y={y(Math.max(c.o, c.c))} height={Math.max(1, Math.abs(y(c.o) - y(c.c)))} fill={col} />
              </g>
            );
          })}
          {levels.map(([l, v, col]) => (
            <g key={l}>
              <line x1={P} x2={W - P} y1={y(v)} y2={y(v)} stroke={col} strokeDasharray="4 4" strokeWidth="1" />
              <text x={W - P - 4} y={y(v) - 3} textAnchor="end" fill={col} fontSize="11" fontFamily="JetBrains Mono">{l} {v}</text>
            </g>
          ))}
        </svg>
      )}
      <div className="flex justify-between text-xs font-mono text-slate-500"><span>min {min.toFixed?.(1)}</span><span>max {max.toFixed?.(1)}</span></div>
    </div>
  );
}
